// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.History .LoadingBlur {
  border-radius: 8px;
}
.History > .card {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1.5rem 1rem;
}
.History > .card > * {
  padding: 0;
  margin: 0;
}
.History > .card > .card-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: hidden;
}
.History .HistoryFilters {
  height: auto;
  background: #fcfcfc;
  border: 1px solid #e3e8ef;
}
.History .HistoryFilters input[name=type]::placeholder {
  color: var(--bs-body-color) !important;
}
.History .HistoryList {
  height: 100%;
  min-height: calc(50vh - var(--header-height));
  max-height: calc(100vh - var(--header-height));
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  overflow: auto;
}
.History .History-Info {
  position: absolute;
  display: flex;
  gap: 0.5rem;
  top: 1rem;
  right: 1rem;
  text-transform: none;
}
.History .History-Info span {
  font-size: 1rem;
  padding-top: 0.33rem;
  color: rgba(0, 0, 0, 0.5);
  font-weight: normal;
}
.History.expanded {
  position: fixed;
  top: 1rem;
  left: 1rem;
  right: 1rem;
  z-index: 9999;
  height: calc(100vh - 2rem) !important;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/History/styles.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAAJ;AACI;EACE,UAAA;EACA,SAAA;AACN;AACI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AACN;AAGE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;AADJ;AAGI;EACE,sCAAA;AADN;AAKE;EACE,YAAA;EACA,6CAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAHJ;AAME;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;AAJJ;AAKI;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;AAHN;AAME;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;AAJJ","sourcesContent":[".History {\n  .LoadingBlur {\n    border-radius: 8px;\n  }\n  > .card {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    padding: 1.5rem 1rem;\n    > * {\n      padding: 0;\n      margin: 0;\n    }\n    > .card-body {\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      overflow: hidden;\n    }\n  }\n\n  .HistoryFilters {\n    height: auto;\n    background: #fcfcfc;\n    border: 1px solid #e3e8ef;\n\n    input[name='type']::placeholder {\n      color: var(--bs-body-color) !important;\n    }\n  }\n\n  .HistoryList {\n    height: 100%;\n    min-height: calc(50vh - var(--header-height));\n    max-height: calc(100vh - var(--header-height));\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    overflow: auto;\n  }\n\n  .History-Info {\n    position: absolute;\n    display: flex;\n    gap: 0.5rem;\n    top: 1rem;\n    right: 1rem;\n    text-transform: none;\n    span {\n      font-size: 1rem;\n      padding-top: 0.33rem;\n      color: rgba(0, 0, 0, 0.5);\n      font-weight: normal;\n    }\n  }\n  &.expanded {\n    position: fixed;\n    top: 1rem;\n    left: 1rem;\n    right: 1rem;\n    z-index: 9999;\n    height: calc(100vh - 2rem) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
